import findResult, { findMatch } from '@/utils/resultsHelper';
import { readStates, saveStates } from '@/constants/lifecycle';

export const datasetConversionState = () => ({
  code: null,
  name: null,
  valid: null,
  status: null,
  dictionaries: [],
  ...readStates,
  ...saveStates,
});

export const dictionaryConversionState = () => ({
  code: null,
  name: null,
  valid: null,
  status: null,
  errors: [],
  selected: false,
  ...readStates,
  ...saveStates,
});

export const datasetValidationState = () => ({
  code: null,
  name: null,
  valid: null,
  status: null,
  dictionaries: [],
  ...readStates,
  ...saveStates,
});

export const dictionaryValidationState = () => ({
  code: null,
  name: null,
  valid: null,
  status: null,
  errors: [],
  selected: false,
  ...readStates,
  ...saveStates,
});

export const activeValidateDataResults = () => ({
  open: false,
  category: null,
  code: null,
  dictionaryCode: null,
  dictionaryName: null,
  valid: null,
  errors: [],
});

export const upsertConversionDictionary = (item, dictionaryCode) => {
  const conversionDictionary = findMatch(item.dictionaries, dictionaryCode);
  if (!conversionDictionary) {
    item.dictionaries.push({
      ...dictionaryConversionState(),
      code: dictionaryCode,
    });
  }
};

export const upsertValidationDictionary = (item, dictionaryCode) => {
  const validationDictionary = findMatch(item.dictionaries, dictionaryCode);
  if (!validationDictionary) {
    item.dictionaries.push({
      ...dictionaryValidationState(),
      code: dictionaryCode,
    });
  }
};

const initialState = {
  dataManagement: {
    open: {
      results: [],
    },
  },
  validateDataResultsDialog: activeValidateDataResults(),
  validateDatasetResultsDialog: {},
};

export const findDatasetData = ({ dataManagement }, { category, code }) => (
  findResult(dataManagement, category, code)
);

export const findDatasetDataDictionary = ({ dataManagement }, { category, code, dictionaryCode }) => {
  const item = findDatasetData({ dataManagement }, { category, code });
  return { item, dictionary: findMatch(item.dictionaries, dictionaryCode) };
};

export default initialState;
